import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import common from 'src/js/modules/common';

const { ControlGroup, InputGroupField, FieldStatus } = designSystem;

const {
  components: { ModalWithPanels },
} = common;

const MODAL_WIDTH = 398;
const MODAL_HEIGHT = 'auto';

const ImageAltDialog = ({ imageElement, control, altFieldName, captions, onSubmit, onCancel }) => (
  <ModalWithPanels
    width={MODAL_WIDTH}
    height={MODAL_HEIGHT}
    captions={{
      title: captions.title,
      submitButton: captions.submit,
      cancelButton: captions.cancel,
    }}
    overlay="visible"
    draggable={false}
    fullscreenOnMobile={false}
    centered
    elementForPositioning={imageElement}
    onSubmit={onSubmit}
    onCancel={onCancel}
    onOverlayClick={onCancel}
    onPressEsc={onCancel}
  >
    <ControlGroup title={captions.label}>
      <InputGroupField control={control} name={altFieldName} />
    </ControlGroup>
    <FieldStatus text={captions.description} />
  </ModalWithPanels>
);

ImageAltDialog.propTypes = {
  imageElement: PropTypes.object.isRequired,
  control: PropTypes.object.isRequired,
  altFieldName: PropTypes.string.isRequired,
  captions: PropTypes.shape({
    title: PropTypes.string.isRequired,
    submit: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default ImageAltDialog;
